import { Org, OrgInfoSubscriptionType, PaywallPopupReason, PopupType } from '@nx-frontend/shared/types';
import { OpenModalFn } from '@nx-frontend/shared/types';
import { GetOpenPayWallPopupProps } from '@nx-frontend/shared/types';

interface ShowBlotsLimitPopupParams {
  openModal: OpenModalFn;
  subscriptionType: OrgInfoSubscriptionType;
  currentOrganization: Org;
  getOpenPaywallPopup: (props: GetOpenPayWallPopupProps) => void;
}

/**
 * Shows paywall popup when blots limit is reached
 * @param params
 */
export function showBlotsLimitPopup(params: ShowBlotsLimitPopupParams) {
  const { openModal, currentOrganization, subscriptionType, getOpenPaywallPopup } = params;

  getOpenPaywallPopup({
    openModal,
    payload: {
      payloadType: PopupType.PAYWALL,
      mode: 'upgrade',
      title: 'Get unlimited blocks by upgrading your plan',
      reason: PaywallPopupReason.BLOCKS_LIMIT,
      orgId: currentOrganization.globalId,
      subscriptionType,
    },
  });
}
